module.exports = {
  apiHost: 'http://localhost:56007',
}
